import { Box, Typography } from '@mui/material';

const OrgDirectoryHeader = () => {
  return (
    <Box mb={2}>
      <Box display="flex" flexDirection="column" gap={1}>
        <Typography variant="h5" fontWeight={600}>
          Org Directory
        </Typography>

        <Typography color="text.secondary">Manage organizations</Typography>
      </Box>
    </Box>
  );
};
export default OrgDirectoryHeader;
